import type { AudienceRule, Rules } from '@/types/types'
import type { Icons } from '@/components/base/BaseIcon.vue'

export type AudienceTemplate = {
  id: number
  type:
    | 'convert_new_subscribers'
    | 'first_visit_recent'
    | 'recent_regulars'
    | 'one_year_loyalty'
    | 'BigSpenders'
    | 'PointsConsumed'
    | 'RegularsOnPause'
    | 'UnusedPoints'
    | 'students'
    | 'young_professionals'
    | 'men'
    | 'women'
  title: string
  description: string
  icon?: Icons
  category?: string
  rules: Partial<Record<Rules, AudienceRule>>
  disabled?: boolean
  isRecommended?: boolean
}
export const AUDIENCE_TEMPLATES_CONFIG: AudienceTemplate[] = [
  {
    id: 1,
    type: 'convert_new_subscribers',
    category: 'attract_convert',
    title: 'pages.audience.templates.1.title',
    description: 'pages.audience.templates.1.description',
    icon: 'IconoirGift',
    rules: {
      registrationDate: { value: [7], operator: 'gt' },
      checkinCount: {
        value: [0],
        operator: 'eq',
        parameters: {
          date_filter: {
            value: [],
            type: 'absolute',
            operator: ''
          }
        }
      }
    },
    disabled: false,
    isRecommended: true
  },
  {
    id: 2,
    type: 'first_visit_recent',
    category: 'attract_convert',
    title: 'pages.audience.templates.2.title',
    description: 'pages.audience.templates.2.description',
    icon: 'IconoirRepeat',
    rules: {
      checkinCount: {
        value: [1],
        operator: 'eq',
        parameters: {
          date_filter: {
            value: [],
            type: 'absolute',
            operator: ''
          }
        }
      },
      lastValidCheckin: { value: [7], operator: 'lte' }
    },
    disabled: false,
    isRecommended: false
  },
  {
    id: 3,
    type: 'recent_regulars',
    category: 'retain_reward',
    title: 'pages.audience.templates.3.title',
    description: 'pages.audience.templates.3.description',
    icon: 'IconoirUserLove',
    rules: {
      checkinCount: {
        value: [3],
        operator: 'gte',
        parameters: {
          date_filter: {
            value: [30],
            type: 'relative',
            operator: 'lt'
          }
        }
      }
    },
    disabled: false,
    isRecommended: false
  },
  {
    id: 4,
    type: 'one_year_loyalty',
    category: 'retain_reward',
    title: 'pages.audience.templates.4.title',
    description: 'pages.audience.templates.4.description',
    icon: 'IconoirBirthdayCake',
    rules: {
      registrationDate: { value: [364], operator: 'gte' }
    },
    disabled: false,
    isRecommended: false
  },
  {
    id: 5,
    type: 'BigSpenders',
    category: 'retain_reward',
    title: 'pages.audience.templates.5.title',
    description: 'pages.audience.templates.5.description',
    icon: 'IconoirTrophy',
    rules: {
      pointCumulated: {
        value: [80],
        operator: 'gte',
        parameters: {
          date_filter: {
            value: [30],
            type: 'relative',
            operator: 'lt'
          }
        }
      }
    },
    disabled: false,
    isRecommended: false
  },
  {
    id: 6,
    type: 'PointsConsumed',
    category: 'reactivate_reengage',
    title: 'pages.audience.templates.6.title',
    description: 'pages.audience.templates.6.description',
    icon: 'IconoirCoins',
    rules: {
      pointTotal: { value: [0], operator: 'eq' },
      pointCumulated: {
        value: [50],
        operator: 'gte',
        parameters: {
          date_filter: {
            value: [],
            type: 'absolute',
            operator: ''
          }
        }
      }
    },
    disabled: false,
    isRecommended: false
  },
  {
    id: 7,
    type: 'RegularsOnPause',
    category: 'reactivate_reengage',
    title: 'pages.audience.templates.7.title',
    description: 'pages.audience.templates.7.description',
    icon: 'IconoirPause',
    rules: {
      averageCheckinCount: { value: [3], operator: 'gte' },
      lastValidCheckin: { value: [45], operator: 'gte' }
    },
    disabled: false,
    isRecommended: true
  },
  {
    id: 8,
    type: 'UnusedPoints',
    category: 'reactivate_reengage',
    title: 'pages.audience.templates.8.title',
    description: 'pages.audience.templates.8.description',
    icon: 'IconoirLullaby',
    rules: {
      pointTotal: { value: [30], operator: 'gt' },
      lastValidCheckin: { value: [60], operator: 'gte' }
    },
    disabled: false,
    isRecommended: true
  },
  {
    id: 9,
    type: 'students',
    category: 'personalize_segment',
    title: 'pages.audience.templates.9.title',
    description: 'pages.audience.templates.9.description',
    icon: 'IconoirGraduationCap',
    rules: {
      age: { value: [23], operator: 'lt' }
    },
    disabled: false,
    isRecommended: false
  },
  {
    id: 10,
    type: 'young_professionals',
    category: 'personalize_segment',
    title: 'pages.audience.templates.10.title',
    description: 'pages.audience.templates.10.description',
    icon: 'HeroBriefcaseIconOutline',
    rules: {
      age: { value: [23, 30], operator: 'between' }
    },
    disabled: false,
    isRecommended: false
  },
  {
    id: 11,
    type: 'men',
    category: 'personalize_segment',
    title: 'pages.audience.templates.11.title',
    description: 'pages.audience.templates.11.description',
    icon: 'IconoirMale',
    rules: {
      gender: { value: ['man'], operator: 'in' }
    },
    disabled: false,
    isRecommended: false
  },
  {
    id: 12,
    type: 'women',
    category: 'personalize_segment',
    title: 'pages.audience.templates.12.title',
    description: 'pages.audience.templates.12.description',
    icon: 'IconoirFemale',
    rules: {
      gender: { value: ['woman'], operator: 'in' }
    },
    disabled: false,
    isRecommended: false
  }
]
